import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
    name: 'safeHtml',
    standalone: false,
})
export class SafeHtmlPipe implements PipeTransform {
    public constructor(private sanitizer: DomSanitizer) {}

    public transform(html: string): SafeResourceUrl {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
